import React from 'react';
import ReactDOM from 'react-dom';
import './global.css';
import 'semantic-ui-css/semantic.min.css';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));